import { GridColumn } from '../../components/Manager/Grid/types';

// Resolves the quick-filter target: the first sorted column (in sort order) that is both filterable and rendered. `columns` already excludes hidden columns, so a sorted-but-hidden column is skipped and the next sorted column is tried. Returns null when no sorted column qualifies.
export const getFirstSortedFilterableColumn = <T extends GridColumn>(
  columns: T[],
  multiSortMeta: { field?: string }[] | undefined
): T | null => {
  for (const sort of multiSortMeta ?? []) {
    const sortedColumn = columns.find((column) => column.name === sort.field);
    if (sortedColumn?.hasFilter) return sortedColumn;
  }

  return null;
};
